import commonDropdownInfos from '@/lib/EpcisData/CommonDropdown.js'
import axios from 'axios'

const getDefaultState = () => ({
  eventCount: 1,
  eventType: null,
  commonDropdownInfos: {},
  showImportDesignModal: false,
  importedDesignData: ''
})

export default {
  namespaced: true,  // 네임스페이스도 추가 권장
  state: getDefaultState,
  mutations: {
    resetDesignData(state) {
      Object.assign(state, getDefaultState())
    },
    eventCountPopulator(state, eventCount) {
      state.eventCount = eventCount
    },
    eventTypePopulator(state, event) {
      state.eventType = event
    },
    commonDropdownInfosPopulate(state, dropdownInfo) {
      state.commonDropdownInfos = dropdownInfo
    },
    populateRawData(state, payload) {
      state.eventCount = payload.eventCount
    },
    showImportDesignModal(state) {
      state.showImportDesignModal = true
    },
    hideImportDesignModal(state) {
      state.showImportDesignModal = false
    },
    populateImportDesignData(state, urlData) {
      state.importedDesignData = urlData
    },
    clearImportDesignData(state) {
      state.importedDesignData = ''
    }
  },
  actions: {
    readStaticData({ commit }) {
      commit('commonDropdownInfosPopulate', commonDropdownInfos)
    },
    obtainURLData({ commit }, inputURL) {
      axios.get(inputURL)
        .then(response => {
          commit('populateImportDesignData', response.data)
        })
        .catch(error => {
          const message = 'Unable to obtain data, request failed. \n' + error + '\n Please check the URL : ' + inputURL
          commit('populateImportDesignData', message)
        })
    }
  }
}